import { render, staticRenderFns } from "./pushChangeList.vue?vue&type=template&id=3e64e20a&scoped=true"
import script from "./pushChangeList.vue?vue&type=script&lang=js"
export * from "./pushChangeList.vue?vue&type=script&lang=js"
import style0 from "./pushChangeList.vue?vue&type=style&index=0&id=3e64e20a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e64e20a",
  null
  
)

export default component.exports